import { render, staticRenderFns } from "./ac-simple-search.vue?vue&type=template&id=cdd8b6d8&"
import script from "./ac-simple-search.vue?vue&type=script&lang=js&"
export * from "./ac-simple-search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports